import { render, staticRenderFns } from "./TravelCommunity.vue?vue&type=template&id=8b691c00&scoped=true&"
import script from "./TravelCommunity.vue?vue&type=script&lang=js&"
export * from "./TravelCommunity.vue?vue&type=script&lang=js&"
import style0 from "./TravelCommunity.vue?vue&type=style&index=0&id=8b691c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b691c00",
  null
  
)

export default component.exports